import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Applauses from '../../components/Applauses';
import MainLayout from '../../layouts/MainLayout';
import logo from '../../assets/logo.svg';

const MyApplauseHubSettings = () => {

  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);



  return (
    <>
      <MainLayout>
        {!isLoggedIn ? (
          <div className='bg-primary text-white h-[100vh] py-8 text-center'>
            <div className='flex justify-center items-center mb-4'>
              <img src={logo} alt='Logo' />
            </div>
            <h1 className='text-2xl' style={{ fontSize: '18px', color: 'yellow' }}> Welcome to Think5Whys</h1>
            <h1 className='text-2xl' style={{ fontSize: '12px' }}> Elevate Your Thinking: From Why To Wisdom</h1>
            <h1 className='text-2xl' style={{ fontSize: '18px', color: 'yellow' }}> World's First People & Business RCA Cloud Powered By AI*</h1>
            <div className="container mx-auto mt-8 p-4">
              <h2 className="text-2xl font-bold mb-4 text-yellow-500">I Want To Analyse</h2>
              <div className="mb-8">
                <div className="text-white">Issue / Challenge / Concern or Incident / Problem</div>
                <div className="text-white">Goal Setting or Decision Making</div>
              </div>
            </div>           
            <Link to="/signup" className='mt-10 text-xl block space-x-2 hover:space-x-4'>
              <span className='transition-[margin]'>Join now to manage your Objectives on Think5Whys Cloud</span>
              <span className='relative ml-4 text-base transition-[margin]'><i className="fa-solid fa-arrow-right"></i></span>
            </Link>
          </div>
        ) : (
          <>
            {/* <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300'>Welcome {authState.user.name}</h3> */}
            <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>My Applause Hub Settings</h3>
            <Applauses />
           </>
        )}
      </MainLayout>
      {/* <Footer /> */}
    </>
  )
}

export default MyApplauseHubSettings